import styled from "styled-components";
import { SX } from "../../shared/types";
import { buildCSSObjectFromSX } from "../../shared/utils";

type Variant = "body" | "body-small" | "body-x-small";

const FONT_SIZE_BY_VARIANT: Record<
  Variant,
  "STANDARD" | "SMALL_MEDIUM" | "SMALL"
> = {
  body: "STANDARD",
  "body-small": "SMALL_MEDIUM",
  "body-x-small": "SMALL",
};

const LINE_HEIGHT_BY_VARIANT: Record<Variant, "NORMAL" | "TIGHT"> = {
  body: "NORMAL",
  "body-small": "TIGHT",
  "body-x-small": "NORMAL",
};

type LinkProps = JSX.IntrinsicElements["a"] & {
  variant: Variant;
  sx?: SX | undefined | null;
};

export const Link = styled.a<LinkProps>(({ theme, variant, sx }) => {
  const cssObject = sx ? buildCSSObjectFromSX(sx, theme) : {};
  return {
    fontFamily: theme.FONT.FAMILY.BODY,
    fontSize: theme.FONT.SIZE[FONT_SIZE_BY_VARIANT[variant]],
    fontStyle: "normal",
    fontWeight: Number(theme.FONT.WEIGHT.REGULAR),
    lineHeight: theme.LINE_HEIGHT[LINE_HEIGHT_BY_VARIANT[variant]],
    color: theme.COLORS.GRAY_BLACK,
    ...cssObject,
  };
});
